import { CustomButton } from "./styles";

interface SubmitButtonProps {
    text: string;
    icon?: any;
    onClick?: () => void;
    disabled?: boolean;
}

const SubmitButton = ({ text, icon, onClick, disabled = false}: SubmitButtonProps) => {
    return (
        <>
        <CustomButton style={{textTransform: "none"}} variant="contained" onClick={onClick} startIcon={icon} disabled={disabled}>{text}</CustomButton>
        </>
    );
}
 
export default SubmitButton;